import React, { useEffect, useRef, useState } from "react"
import classNames from "classnames"
import { noop } from "lodash-es"
import { create } from "zustand"

import { SFX } from "@/topic/rogue_5/utils/sfx"
import { needFixWritingMode } from "@/utils/misc"

import styles from "./index.module.less"

const useResultModalStore = create<{
    activate: (
        result: {
            special?: boolean
            title?: string
            titleEn?: string
            content?: string
            icon?: string
        },
        onExit?: () => void
    ) => void
}>(() => ({
    activate: noop,
}))

export const useResultModal = () =>
    useResultModalStore((state) => state.activate)

const ResultModal: React.FC<{
    className?: string
    style?: React.CSSProperties
}> = ({ className, style }) => {
    const [active, setActive] = useState(false)
    const animating = useRef(false)
    const [result, setResult] = useState<{
        special?: boolean
        title?: string
        titleEn?: string
        content?: string
        icon?: string
    }>({})
    // const onExitRef = useRef<() => void>()
    useEffect(() => {
        useResultModalStore.setState({
            activate: (result, onExit) => {
                if (animating.current) return
                SFX.play("resultModal")
                animating.current = true
                setActive(true)
                setResult(result)
                // onExitRef.current = onExit
                setTimeout(() => {
                    animating.current = false
                    setActive(false)
                    onExit?.()
                }, 2500)
            },
        })
    }, [])
    const titleText = result.title?.split("\n")
    return (
        <div
            className={classNames(
                styles.modalContainer,
                active && styles.active,
                result.special && styles.special,
                className
            )}
            style={style}
            // onClick={() => {
            //     animating.current = false
            //     setActive(false)
            //     onExitRef.current?.()
            // }}
        >
            {active && (
                <>
                    <div className={classNames(styles.light)}>
                        <div className={styles.rt}></div>
                        <div className={styles.rb}></div>
                        <div className={styles.lb}></div>
                    </div>
                    <div className={styles.contentContainer}>
                        <div className={classNames(styles.iconLight)}>
                            <div className={styles.weak}></div>
                            <div className={styles.strong}></div>
                        </div>
                        <div
                            className={classNames(
                                styles.icon,
                                result.icon ? styles[result.icon] : styles.lotus
                            )}
                        ></div>
                        <div className={styles.decoLine}></div>
                        <div
                            className={classNames(
                                styles.title,
                                needFixWritingMode() && styles.safari
                            )}
                        >
                            <div className={styles.titleText}>
                                {titleText?.[0]?.split("").map((c, index) => (
                                    <span
                                        className={styles.char}
                                        key={`${c}-${index}`}
                                    >
                                        {c}
                                    </span>
                                ))}
                            </div>
                            <div className={styles.titleText}>
                                {titleText?.[1]?.split("").map((c, index) => (
                                    <span
                                        className={styles.char}
                                        key={`${c}-${index}`}
                                    >
                                        {c}
                                    </span>
                                ))}
                            </div>
                            <div className={styles.jieqian}></div>
                        </div>
                        <div className={styles.pinyin}>
                            {result.titleEn?.split("\n").map((c, index) => (
                                <div
                                    className={styles.item}
                                    key={`${c}-${index}`}
                                >
                                    {c}
                                </div>
                            ))}
                        </div>
                        <div className={styles.detail}>{result.content}</div>
                    </div>
                </>
            )}
        </div>
    )
}

export default ResultModal
